import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const officePayload = payload.find(p => p.dataKey === 'officeRevenue');
    const schoolPayload = payload.find(p => p.dataKey === 'schoolRevenue');
    const total = (officePayload?.value || 0) + (schoolPayload?.value || 0);

    return (
      <div style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.95)', 
        border: '1px solid #e0e0e0', 
        padding: '15px', 
        borderRadius: '10px', 
        boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
        minWidth: '240px'
      }}>
        <p style={{ 
          margin: 0, 
          fontWeight: 'bold', 
          paddingBottom: '10px', 
          borderBottom: '1px solid #eee',
          color: '#3f51b5',
          fontSize: '0.95rem'
        }}>
          {label}
        </p>
        <ul style={{ 
          paddingLeft: 0, 
          listStyle: 'none', 
          marginTop: '10px',
          marginBottom: 0
        }}>
          {officePayload && (
            <li style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              margin: '8px 0',
              color: '#3f51b5'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ 
                  width: '12px', 
                  height: '12px', 
                  backgroundColor: '#3f51b5', 
                  borderRadius: '2px', 
                  marginRight: '8px' 
                }}></div>
                <span>รายรับ Office:</span>
              </div>
              <span style={{ fontWeight: 600 }}>฿{officePayload.value.toLocaleString()}</span>
            </li>
          )}
          {schoolPayload && (
            <li style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              margin: '8px 0',
              color: '#00bcd4'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ 
                  width: '12px', 
                  height: '12px', 
                  backgroundColor: '#00bcd4', 
                  borderRadius: '2px', 
                  marginRight: '8px' 
                }}></div>
                <span>รายรับจากโรงเรียน:</span>
              </div>
              <span style={{ fontWeight: 600 }}>฿{schoolPayload.value.toLocaleString()}</span>
            </li>
          )}
          <li style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginTop: '12px',
            paddingTop: '12px',
            borderTop: '1px solid #eee',
            fontWeight: 'bold',
            color: '#37474f'
          }}>
            <span>รวมทั้งหมด:</span>
            <span>฿{total.toLocaleString()}</span>
          </li>
        </ul>
      </div>
    );
  }
  return null;
};

const TrendLineChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ 
        height: 400, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        color: '#90a4ae', 
        fontSize: '1.1rem',
        background: 'rgba(245, 248, 250, 0.6)',
        borderRadius: '12px',
        border: '1px dashed #cfd8dc'
      }}>
        ไม่มีข้อมูลสำหรับตัวกรองที่เลือก
      </div>
    );
  }
  
  return (
    <ResponsiveContainer width="100%" height={500}>
      <AreaChart 
        data={data} 
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <defs>
          <linearGradient id="colorOffice" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3f51b5" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#3f51b5" stopOpacity={0.1}/>
          </linearGradient>
          <linearGradient id="colorSchool" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#00bcd4" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#00bcd4" stopOpacity={0.1}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
        <XAxis 
          dataKey="name" 
          tick={{ fontSize: 12, fill: '#546e7a' }} 
          axisLine={false}
          tickLine={false}
        />
        <YAxis 
          tickFormatter={(value) => `${value / 1000}k`} 
          tick={{ fontSize: 12, fill: '#546e7a' }} 
          axisLine={false}
          tickLine={false}
        />
        <Tooltip 
          content={<CustomTooltip />} 
          cursor={{ stroke: '#90a4ae', strokeDasharray: '3 3' }}
        />
        <Legend 
          verticalAlign="top" 
          height={50}
          iconType="circle"
          iconSize={10}
          formatter={(value, entry, index) => (
            <span style={{ color: '#37474f', fontSize: '0.85rem' }}>{value}</span>
          )}
        />
        <Area 
          type="monotone" 
          dataKey="officeRevenue" 
          stackId="1" 
          stroke="#3f51b5" 
          fill="url(#colorOffice)"
          strokeWidth={2}
          name="รายรับ Office"
          activeDot={{ r: 6, stroke: '#fff', strokeWidth: 2 }}
        />
        <Area 
          type="monotone" 
          dataKey="schoolRevenue" 
          stackId="1" 
          stroke="#00bcd4" 
          fill="url(#colorSchool)"
          strokeWidth={2}
          name="รายรับจากโรงเรียน"
          activeDot={{ r: 6, stroke: '#fff', strokeWidth: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default TrendLineChart;